import { z } from 'zod';
import { JsonParseError } from 'libs/end-to-end/src/types/errors/json-parse-error';
import { OrganizationContractAlreadyExistsError } from 'libs/end-to-end/src/types/errors/organization-contract-already-exists-error';
import { OrganizationContractNotFoundError } from 'libs/end-to-end/src/types/errors/organization-contract-not-found-error';
import { OrganizationHasNoCompleteUploadsError } from 'libs/end-to-end/src/types/errors/organization-has-no-complete-uploads-error';
import { OrganizationIdAlreadyTakenError } from 'libs/end-to-end/src/types/errors/organization-id-already-taken-error';
import { OrganizationNameAlreadyTakenError } from 'libs/end-to-end/src/types/errors/organization-name-already-taken-error';
import { OrganizationNotFoundError } from 'libs/end-to-end/src/types/errors/organization-not-found-error';
import { S3StorageError } from 'libs/end-to-end/src/types/errors/s3-storage-error';
import { UnknownError } from 'libs/end-to-end/src/types/errors/unknown-error';
import { OrganizationDemographicConfigsNotFoundError } from 'libs/end-to-end/src/types/errors/organization-demographic-configs-not-found-error';
import { OrganizationDemographicConfigsAlreadyExistsError } from 'libs/end-to-end/src/types/errors/organization-demographic-configs-already-exists-error';
import { BufferToStringError } from 'libs/end-to-end/src/types/errors/buffer-to-string-error';
import { OrganizationHasUsersError } from 'libs/end-to-end/src/types/errors/organization-has-users-error';
import { OrganizationHasDatabasesError } from 'libs/end-to-end/src/types/errors/organization-has-databases-error';
import { RdbmsError } from 'libs/end-to-end/src/types/errors/rdbms-error';

export const OrganizationError = z.union([
  S3StorageError,
  JsonParseError,
  OrganizationNotFoundError,
  OrganizationNameAlreadyTakenError,
  OrganizationHasNoCompleteUploadsError,
  OrganizationIdAlreadyTakenError,
  OrganizationContractNotFoundError,
  OrganizationContractAlreadyExistsError,
  OrganizationDemographicConfigsAlreadyExistsError,
  OrganizationDemographicConfigsNotFoundError,
  BufferToStringError,
  UnknownError,
  OrganizationHasUsersError,
  OrganizationHasDatabasesError,
  RdbmsError,
]);

export type OrganizationError = z.infer<typeof OrganizationError>;
